<template>
  <div class="sortable-item sortable-item-document width-fit-content">
    <span class="sortable-item-info">
      <span class="sortable-item-type">
        Documento <span class="sortable-item-type-position">( {{ index + 1 }} )</span>
      </span>
      <span class="sortable-item-action sortable-item-move">
        <i class="far fa-arrows-alt"></i>
      </span>
      <a
        class="sortable-item-action sortable-item-delete"
        href="#"
        @click.prevent="deleteBlock"
      >
        <i class="far fa-trash-alt"></i>
      </a>
    </span>
    <div class="sortable-item-tag">
      <a
        :href="block.data.url ? block.data.url : block.data.file"
        class="file-document-access"
        target="_blank"
        download
      >
        <span class="file-document-access-icon">
          <i :class="iconClass"></i>
        </span>
        <span class="file-document-access-info">
          <span class="file-document-access-info-name">
            {{ block.data.name }}
          </span>
          <span class="file-document-access-info-action">
            <i class="far fa-arrow-to-bottom font-size-small"></i>
          </span>
        </span>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MoleculeContentEditorBlockDocument',

  props: {
    block: Object,
    canEdit: {
      type: Boolean,
      default: true
    },
    index: Number,
    time: {
      type: Number,
      default: null
    }
  },

  data () {
    return {
      iconClasses: {
        doc: 'far fa-file-word text-color-content-document-word',
        docx: 'far fa-file-word text-color-content-document-word',
        gif: 'far fa-file-image text-color-content-document',
        jpg: 'far fa-file-image text-color-content-document',
        jpeg: 'far fa-file-image text-color-content-document',
        pdf: 'far fa-file-pdf text-color-content-document-pdf',
        png: 'far fa-file-image text-color-content-document',
        ppt: 'far fa-file-powerpoint text-color-content-document-ppt',
        pptx: 'far fa-file-powerpoint text-color-content-document-ppt',
        txt: 'far fa-file-alt text-color-content-document',
        xls: 'far fa-file-excel text-color-content-document-excel',
        xlsx: 'far fa-file-excel text-color-content-document-excel',
        zip: 'far fa-file-archive text-color-content-document'
      }
    }
  },

  computed: {
    iconClass () {
      return this.iconClasses[this.block.data.name.split('.').pop()]
    }
  },

  methods: {
    deleteBlock () {
      if (this.canEdit) {
        this.$emit('deleteBlock', this.index)
      }
    }
  }
}
</script>
